import { render, staticRenderFns } from "./SubCategoryDetails.vue?vue&type=template&id=49f7f366&scoped=true"
import script from "./SubCategoryDetails.vue?vue&type=script&lang=js"
export * from "./SubCategoryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f7f366",
  null
  
)

export default component.exports